import { SvgIcon, SxProps } from "@mui/material";
import CheckSvg from "jsx:../../../Images/Icons/FontAwesome/regular/check.svg";

export function CheckRegularIcon(props: SxProps) {
    return <SvgIcon component={CheckSvg} inheritViewBox sx={props} />;
}
